__turbopack_context__.v({
  "button": "teams-purchase-slider-menu-content-module-scss-module__nSWiuq__button",
});
